"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STORAGE_KEY_DESIRED_LOCALE = exports.SUPPORTED_LOCALES = exports.DEFAULT_LOCALE = void 0;
var DEFAULT_LOCALE = "en-GB";
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
var SUPPORTED_LOCALES = ["en-GB", "de", "pt", "he", "ko", "tr"];
exports.SUPPORTED_LOCALES = SUPPORTED_LOCALES;
var STORAGE_KEY_DESIRED_LOCALE = "locale";
exports.STORAGE_KEY_DESIRED_LOCALE = STORAGE_KEY_DESIRED_LOCALE;